import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Home = () => {
  const mainSlider = useRef(null);
  const thumbSlider = useRef(null);
  const [progress, setProgress] = useState(0);
  const sliderRef = useRef(null);

 

  const mainSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    autoplay: false,
    infinite: false,
    speed: 800,
    asNavFor: thumbSlider.current,
    adaptiveHeight: false,
    afterChange: (index) => setProgress(Math.round(((index + 1) / 5) * 100)),
  };

  const thumbSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    autoplay: false,
    infinite: false,
    speed: 800,
    asNavFor: mainSlider.current,
    adaptiveHeight: false,
  };


    const serviceSlider = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1100, settings: { slidesToShow: 2 } },
      { breakpoint: 900, settings: { slidesToShow: 2 } },
      { breakpoint: 500, settings: { slidesToShow: 1 } }
    ]
  };

  const testimonialSlider = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1370, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 800, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 300, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  };

  const prevSlide = () => mainSlider.current.slickPrev();
  const nextSlide = () => mainSlider.current.slickNext();


  return (
    <>
      <section className="main_slider">
        <Slider {...mainSettings} ref={mainSlider} className="bannerBgSlider">
          <div>
            <div className="banner-bg-slider-img">
              <img
                src="images/banner1.webp"
                alt="Banner 1"
              />
            </div>
          </div>
          <div>
            <div className="banner-bg-slider-img">
              <img
                src="images/banner2.webp"
                alt="Banner 2"
              />
            </div>
          </div>
          <div>
            <div className="banner-bg-slider-img">
              <img
                src="images/banner3.webp"
                alt="Banner 3"
              />
            </div>
          </div>
          <div>
            <div className="banner-bg-slider-img">
              <img
                src="images/banner4.webp"
                alt="Banner 4"
              />
            </div>
          </div>
          <div>
            <div className="banner-bg-slider-img">
              <img
                src="images/banner5.webp"
                alt="Banner 5"
              />
            </div>
          </div>
        </Slider>

        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-lg-6 col-md-8 col-sm-4 align-self-center">
              <div className="banner_text">
                <h1>
                  <span>
                    Where Vision Takes
                    <br />
                    Shape in Curated Luxury
                  </span>
                </h1>
              </div>
            </div>

            <div className="col-lg-6 col-md-4 col-sm-12 p-0 align-self-center">
              <div className="banner_img-prev">
                <Slider {...thumbSettings} ref={thumbSlider} className="bannerSmallSlider">
                  <div>
                    <div className="banner-small-slider-img">
                      <img
                        src="images/banner1.webp"
                        alt="Thumbnail 1"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="banner-small-slider-img">
                      <img
                        src="images/banner2.webp"
                        alt="Thumbnail 2"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="banner-small-slider-img">
                      <img
                        src="images/banner3.webp"
                        alt="Thumbnail 3"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="banner-small-slider-img">
                      <img
                        src="images/banner4.webp"
                        alt="Thumbnail 4"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="banner-small-slider-img">
                      <img
                        src="images/banner5.webp"
                        alt="Thumbnail 5"
                      />
                    </div>
                  </div>
                </Slider>
                <div className="banner-slider-conterl">
                  <div className="custom-flex">
                    <div className="banner-silder-text">
                      <h6>Next up</h6>
                      <h5>Luxury Redefined</h5>
                    </div>
                    <div className="banner-slider-btn">
                      <button onClick={prevSlide} className="slider-prev">
                        <i className="fa-solid fa-caret-left"></i>
                      </button>
                      <button onClick={nextSlide} className="slider-next">
                        <i className="fa-solid fa-caret-right"></i>
                      </button>
                    </div>
                  </div>

                  <div className="nike-zoom-progress-barchg">
                    <div
                      className="progress"
                      role="progressbar"
                      aria-valuemin={0}
                      aria-valuemax={100}
                      aria-valuenow={progress}
                      style={{ backgroundSize: `${progress}% 100%` }}
                    >
                      <span className="slider__label sr-only">{progress}% completed</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="new-collaborator-sec">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="section-heading">
                <h2>
                  Our Curated Collaborators
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/colab-3-68f21f239d5ae.webp" alt="" />
                </div>
                <div className="collab-text">
                  <Link to="https://www.luxedecorbygg.com/">LUXE DÉCOR BY GIORGIO GRAESAN LTD</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/colab-7-68f21f241e680.webp" alt="collab" />
                </div>
                <div className="collab-text">
                  <Link to="http://www.luxecucinebyaster.co.uk/">LUXE CUCINE BY ASTER LTD</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/colab-2-68f21f23131c1.webp" alt="collab" />
                </div>
                <div className="collab-text">
                  <Link to="#">SUB ZERO &amp; WOLF</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/colab-1-68f21f2217d95.webp" alt="collab" />
                </div>
                <div className="collab-text">
                  <Link to="#">1810 SINKS</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/brandm-2-68f21f22216c8.webp" alt="collab" />
                </div>
                <div className="collab-text">
                  <Link to="#">MOMENTI</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/colab-5.jpg" alt="" />
                </div>
                <div className="collab-text">
                  <Link to="#">KARE DESIGN</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/jrstone-68f21f2920029.webp" alt="collab" />
                </div>
                <div className="collab-text">
                  <Link to="#">JR STONE</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/top-ciment-68f21f20db16b.webp" alt="collab" />
                </div>
                <div className="collab-text">
                  <Link to="#">TOP CIMENT</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/colab-55.jpg" alt="" />
                </div>
                <div className="collab-text">
                  <Link to="#">ANTONIO LISO <br /> DECORIAMO NOI </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/alessie.jpg" alt="" />
                </div>
                <div className="collab-text">
                  <Link to="#">ALESSI</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/slettie-68f21f286b07c.webp" alt="" />
                </div>
                <div className="collab-text">
                  <Link to="#">SELETTI</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collab-box">
                <div className="collab-image">
                  <img src="images/tmleadercontract-68f21f1f8b92a.jpg" alt="" />
                </div>
                <div className="collab-text">
                  <Link to="#">TM Leader Contract</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="about-sec">
        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-5 col-sm-12 col-12">
              <div className="about-img">
                <img src="images/about.jpg" alt="Enter a Space Curated for Visionaries" />
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-7 col-sm-12 col-12">
              <div className="about-text">
                <h2>Enter a Space Curated for Visionaries</h2>
                <ul>
                  <li>
                    <h5>About us</h5>
                  </li>
                  <li>
                    <p /><p>At The Design Showroom, we believe great design begins with imagination and is brought to life through intention. As part of the Luxe Family portfolio, our concept showroom in West London blends timeless elegance with innovative craftsmanship—featuring an expertly curated selection of luxury interiors and exteriors. From artisanal wall finishes and bespoke surfaces to modular Italian kitchens, micro cement textures, and premium fittings, every element is chosen to inspire architects, designers, developers, and discerning homeowners.</p>
                    <p>This is more than a showroom—it’s an immersive design destination. Our clients can experience products firsthand, engage with lifestyle displays, and receive personalized guidance from our expert team. We proudly showcase world-class partners including Momenti, Antonio Liso, Top Ciment, JR Stone, and 1810 Sinks, alongside signature brands like Luxe Cucine, Luxe LED, and Luxe Décor by Giorgio Graesan. Whether you're crafting a statement residence or a landmark commercial space, The Design Showroom offers the textures, tools, and tailored solutions to elevate every detail—with curated luxury at its core.</p><p />
                    <Link to="/about-us" className="theme-btn-1"><span>Enquire Now</span></Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bespoke-sec" style={{ backgroundImage: 'url(images/0.11224600 1752713998_Bespoke.png)' }}>
        <div className="bespoke-bg-img">
          <div className="bespoke-content">
            <h2 className="bespoke-title">
              <span className="title-top">Signature </span>
              <span className="title-bottom"><h2>Style Solutions</h2></span>
            </h2>
          </div>
        </div>
      </section>

      <section className="service-sec">
        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-12">
              <div className="service-heading">
                <h2>Our Signature Approach</h2>
                <div className="serviceSlider-btn">
                  <button
                    className="service-btn"
                    onClick={() => sliderRef.current.slickPrev()}
                  >
                    <i className="fa-solid fa-caret-left"></i>
                  </button>
                  <button
                    className="service-btn"
                    onClick={() => sliderRef.current.slickNext()}
                  >
                    <i className="fa-solid fa-caret-right"></i>
                  </button>
                </div>
              </div>
            </div>

            <div className="col-12">
              <Slider ref={serviceSlider} {...serviceSlider} className="serviceSlider">
                <div>
                  <div className="service-box">
                    <div className="service-text">
                      <h5>01</h5>
                      <h4>Curated Product Sourcing</h4>
                      <p>
                        We bring premium global design brands into one curated
                        showroom, making it easy to source high-quality finishes
                        and find creative inspiration.
                      </p>
                      <Link
                        to="/service-detail/curated-product-sourcing"
                        className="theme-btn-1"
                      >
                        <span>More Detail</span>
                      </Link>
                    </div>
                    <div className="service-img">
                      <img
                        src="images/service-img-1175277391991.png"
                        alt="Curated Product Sourcing"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="service-box">
                    <div className="service-text">
                      <h5>02</h5>
                      <h4>Bespoke Surface &amp; Finish Solutions</h4>
                      <p>
                        We offer custom surface solutions—from Venetian plaster to
                        marble countertops—expertly crafted to enhance Luxe Cucine
                        kitchens and luxury interiors with style and function.
                      </p>
                      <Link
                        to="/service-detail/bespoke-surface-finish-solutions"
                        className="theme-btn-1"
                      >
                        <span>More Detail</span>
                      </Link>
                    </div>
                    <div className="service-img">
                      <img
                        src="images/bespoke175865471667.jpg"
                        alt="Bespoke Surface & Finish Solutions"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="service-box">
                    <div className="service-text">
                      <h5>03</h5>
                      <h4>Design Consultation &amp; Collaboration</h4>
                      <p>
                        We partner with design professionals to turn concepts into
                        refined spaces, offering expert guidance, material pairing,
                        and aesthetic alignment from start to finish.
                      </p>
                      <Link
                        to="/service-detail/design-consultation-collaboration"
                        className="theme-btn-1"
                      >
                        <span>More Detail</span>
                      </Link>
                    </div>
                    <div className="service-img">
                      <img
                        src="images/corian-plus-sink1175865487471.jpg"
                        alt="Design Consultation & Collaboration"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="service-box">
                    <div className="service-text">
                      <h5>04</h5>
                      <h4>Integrated Brand Partnerships</h4>
                      <p>
                        Through exclusive partnerships with top brands, we offer
                        clients unique collections, innovative finishes, and
                        custom solutions—all curated in our concept showroom.
                      </p>
                      <Link
                        to="/service-detail/integrated-brand-partnerships"
                        className="theme-btn-1"
                      >
                        <span>More Detail</span>
                      </Link>
                    </div>
                    <div className="service-img">
                      <img
                        src="images/ser2175862649739.webp"
                        alt="Integrated Brand Partnerships"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="service-box">
                    <div className="service-text">
                      <h5>05</h5>
                      <h4>Luxury Kitchen &amp; Bath Enhancements</h4>
                      <p>
                        We provide bespoke kitchen and bath solutions featuring
                        Luxe Cucine cabinetry, premium finishes, and 1810
                        sinks—combining Italian design with personalized luxury.
                      </p>
                      <Link
                        to="/service-detail/luxury-kitchen-bath-enhancements"
                        className="theme-btn-1"
                      >
                        <span>More Detail</span>
                      </Link>
                    </div>
                    <div className="service-img">
                      <img
                        src="images/vegetables-ver175857788764.jpg"
                        alt="Luxury Kitchen & Bath Enhancements"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="service-box">
                    <div className="service-text">
                      <h5>06</h5>
                      <h4>Trade Support for Professionals</h4>
                      <p>
                        Design professionals trust our expert support—from
                        material selection to specification—to streamline projects
                        while ensuring creative freedom and precise execution.
                      </p>
                      <Link
                        to="/service-detail/trade-support-for-professionals"
                        className="theme-btn-1"
                      >
                        <span>More Detail</span>
                      </Link>
                    </div>
                    <div className="service-img">
                      <img
                        src="images/tone_athroom175865506296175883589887.jpg"
                        alt="Trade Support for Professionals"
                      />
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </section>
      <section className="why-choose-sec">
        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="why-choose-text">
                <h2>What Sets Us Apart</h2>
                <p>At The Design Showroom, we deliver curated luxury through world-class interiors and personalized design support. Our West London showroom features exclusive brands like Momenti, JR Stone, Top Ciment, and 1810 Sinks—offering bespoke kitchens, refined finishes, and premium surfaces all in one space.</p>
                <ul>
                  <li>
                    <p>We work closely with clients and professionals to transform concepts into beautifully executed spaces, combining quality, innovation, and tailored service at every step.</p>
                    <p><img alt="img" src="images/why-choose-icon.png" /> One-Stop Destination for Luxury Interiors &amp; Exteriors</p>
                    <p><img alt="img" src="images/why-choose-icon.png" /> Fully Customized Solutions to Reflect Your Lifestyle</p>
                    <p><img alt="img" src="images/why-choose-icon.png" /> Trusted by Architects, Designers &amp; Property Developers</p>
                    <p><img alt="img" src="images/why-choose-icon.png" /> Premium Access to Globally Celebrated Design Brands</p>
                  </li>
                </ul></div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="why-choose-img">
                <img src="images/why-choose.webp" alt="What Sets Us Apart" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonial_sec">
        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-12">
              <div className="section-heading">
                <h2>Words from the Inspired</h2>
              </div>
            </div>
          </div>

          <div className="container-fluid add-padding">
            <Slider ref={sliderRef} {...testimonialSlider} className="testimonial_slider">
              <div>
                <div className="testimonial_box">
                  <i className="fa-solid fa-quote-left"></i>
                  <div className="rate">
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked testimonial_boxspan"></span>
                  </div>
                  <p>
                    "Walking into The Design Showroom felt like stepping into a
                    world built for people who love great design. Their team
                    helped us pair the perfect kitchen with bespoke wall
                    textures—and everything looks and feels incredible. Its
                    luxury without getting overwhelmed."
                  </p>
                  <div className="profile">
                    <img
                      src="images/testimonial_slider-img-1.png"
                      alt="Sophia Malik"
                    />
                    <div className="profile_text">
                      <h6>Sophia Malik</h6>
                      <p>Homeowner</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 2 */}
              <div>
                <div className="testimonial_box">
                  <i className="fa-solid fa-quote-left"></i>
                  <div className="rate">
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked testimonial_boxspan"></span>
                  </div>
                  <p>
                    "As a designer, having all these top-tier brands under one
                    roof is a game-changer. From Momenti’s artistic finishes to
                    JR Stone’s custom marble, everything I need is right here—plus
                    the team offers real insight and flexibility. A truly
                    inspiring space."
                  </p>
                  <div className="profile">
                    <img
                      src="images/testimonial_slider-img-1.png"
                      alt="Clara James"
                    />
                    <div className="profile_text">
                      <h6>Clara James</h6>
                      <p>Interior Designer</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 3 */}
              <div>
                <div className="testimonial_box">
                  <i className="fa-solid fa-quote-left"></i>
                  <div className="rate">
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked testimonial_boxspan"></span>
                  </div>
                  <p>
                    "The Design Showroom is our go-to destination for premium
                    materials and expert guidance. Their curated selection—from
                    marble surfaces to modular kitchens—saves us time and elevates
                    every project we deliver. A rare combination of luxury,
                    efficiency, and partnership."
                  </p>
                  <div className="profile">
                    <img
                      src="images/testimonial_slider-img-1.png"
                      alt="Daniel Wright"
                    />
                    <div className="profile_text">
                      <h6>Daniel Wright</h6>
                      <p>Property Developer</p>
                    </div>
                  </div>
                </div>
              </div>

            </Slider>
          </div>
        </div>
      </section>


    </>
  );
};

export default Home;
